import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ICountryDto } from '@models/country-dto';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';
import { IStateDto } from '@models/state-dto';
import { CountryService } from '@shared/services/country.service';
import { LoadingService } from '@shared/services/loading.service';
import { StateService } from '@shared/services/state.service';
import { filter, map, switchMap, tap } from 'rxjs';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { StatesPostForm, StatesPostFormFg } from './form/states-post-form';


@Component({
  selector: 'sigecom-edit-states',
  templateUrl: './edit-states.component.html',
})
export class EditStatesComponent extends BaseComponent implements OnInit {

  countryService = inject(CountryService);
  stateService = inject(StateService);
  loadingService = inject(LoadingService);

  countryOptions?:IPage<ICountryDto>
  stateDto?: IStateDto;
  statesPostForm:FormGroup<StatesPostFormFg>

  selectedCountry?:ICountryDto;
 

  constructor(){
    super();
    this.statesPostForm = this.fb.group<StatesPostFormFg>({
      paiNrId : this.fb.control(null,Validators.required),
      estTxDescricao:this.fb.control(null,Validators.required),
      estTxSigla:this.fb.control(null,[Validators.required,Validators.minLength(2),Validators.maxLength(2)])
    })
  }

  ngOnInit(): void {
     this.initEditState();  
  }

  initEditState(){

    this.activatedRoute.paramMap
          .pipe(
            map(params => params.get("estNrId")),
            filter(idString => !!idString),
            map(idString => Number.parseInt(idString!)),
            tap(() => {
             this.loadingService.activate();
             this.loadOptionsCountry({page:0,size:10});
            }),
            switchMap((estNrId) => {
              return this.stateService.getStateById(estNrId)
            })
          ).subscribe({
            next: (state) => {
             this.stateDto = state;
             this.uptdateStatePostForm(state);
             this.statesPostForm.controls.paiNrId.patchValue(state.estObjPais.paiNrId)
             this.selectedCountry = state.estObjPais;
             this.loadingService.deactivate();
            }
          });
  }

  loadOptionsCountry(page:PageRequest,text?:string){
      this.countryService.getAllCountries(page.page,page.size,text).subscribe((countries) => this.countryOptions = countries);
  }

  goToStatesList(){
      this.router.navigate(["/estados"])
  }

  uptdateStatePostForm(state: IStateDto) {
    this.statesPostForm.controls.estTxDescricao.setValue(state.estTxDescricao);
    this.statesPostForm.controls.estTxSigla.setValue(state.estTxSigla);
  }

  submitForm(){
    const formValue = this.statesPostForm.controls;
    const submitForm = new StatesPostForm(formValue);
    
    submitForm.verifyChanges(this.stateDto!)

    this.stateService.updateState(submitForm).subscribe({
      next: (state) => {
        this.stateDto = state;
        this.snackbarService.showSuccess('Estado atualizado com Sucesso');
      },
      complete: () => this.uptdateStatePostForm(this.stateDto!)
    })
  }
}
